var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIconDonut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42846",
    "data-name": "Group 42846",
    transform: "translate(-696 -319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42632",
    "data-name": "Group 42632",
    transform: "translate(696 319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42612",
    "data-name": "Group 42612",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6222",
    "data-name": "Rectangle 6222",
    fill: "#fff",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 3.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Donut_chart",
    "data-name": "Donut chart",
    transform: "translate(701 324)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 20,
    height: 20,
    transform: "translate(0 0)",
    fill: "#e0e0e0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_donut_chart_1613973",
    "data-name": "noun_donut chart_1613973",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42872",
    "data-name": "Group 42872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70248",
    "data-name": "Path 70248",
    d: "M14.5,5A9.5,9.5,0,1,0,24,14.5,9.51,9.51,0,0,0,14.5,5Zm-.633,1.293V8.411A6.122,6.122,0,1,0,18.359,19.25l1.5,1.5a8.231,8.231,0,1,1-5.99-14.455Zm1.267,0a8.217,8.217,0,0,1,7.574,7.574H20.589a6.139,6.139,0,0,0-5.456-5.456ZM14.5,9.644A4.856,4.856,0,1,1,9.644,14.5,4.846,4.846,0,0,1,14.5,9.644Zm6.089,5.489h2.118a8.186,8.186,0,0,1-1.953,4.724l-1.5-1.5A6.086,6.086,0,0,0,20.589,15.133Z",
    transform: "translate(-5 -5)",
    fill: "#85888a",
    stroke: "#85888a",
    strokeWidth: 0.2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIconDonut);
export default __webpack_public_path__ + "static/media/chart-icon-donut.e6cddf17.svg";
export { ForwardRef as ReactComponent };